import { render, staticRenderFns } from "./SplitList.vue?vue&type=template&id=1d1b3232&scoped=true"
import script from "./SplitList.vue?vue&type=script&lang=js"
export * from "./SplitList.vue?vue&type=script&lang=js"
import style0 from "./SplitList.vue?vue&type=style&index=0&id=1d1b3232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1b3232",
  null
  
)

export default component.exports